import { create } from 'zustand';
import { createJSONStorage, persist } from "zustand/middleware";
import { RydUserAccount } from '../accounts/model';

export interface CurrentUserAccountState {
    account: RydUserAccount | null;
    setAccount: (account: RydUserAccount) => void;
    clearAccount: () => void;
}

export const useCurrentUserAccountStore = create<CurrentUserAccountState>((set) => ({
    account: null,
    setAccount: (account: RydUserAccount) => set({ account }),
    clearAccount: () => set({ account: null }),
}));

export type RydSession = {
    account: RydUserAccount;
    accessToken: string | null;
    refreshToken: string | null;
}

export type RydSessionState = {
    user: RydUserAccount | null;
    accessToken: string | null;
    refreshToken: string | null;
    setUser: (user: RydUserAccount) => void;
    setTokens: (accessToken: string, refreshToken: string) => void;
    logout: () => void;
}

export const useUserSession = create<RydSessionState>()(
    persist(
        (set, get) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            setUser: (user) => set({ user }),
            setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
            logout: () => set({ user: null, accessToken: null, refreshToken: null }),
        }),
        {
            name: "user-session", // the key used in localStorage to store the session
            storage: createJSONStorage(() => localStorage), // use localStorage to persist the state
        }
    ),
);